import axios from 'axios'

axios.defaults.withCredentials = true

export default {
    state : { 
        baseUrl:process.env.API_URL
    },
    getters : {
    },
    mutations : { 
    },
    actions : { 
        deleteProducts({state,commit},form){

            return new Promise((resolve, reject) => {
                axios.post(`${state.baseUrl}/deleteProducts`,form)
                .then(response => {
                    console.log("deleteProducts action response")
                    console.log(response)
                    if(response.data.status.code==0){
                        /*
                        commit('organization',response.data.content.organization)
                        commit('user',response.data.user)
                        commit('users',response.data.users)
                        commit('organizationCustomFields',response.data.content.customFields)
                        resolve(response.data)
                        */
                       resolve(response.data)
                    }else{
                        resolve(response.data)
                    }
                })
                .catch(e => {
                    console.log(e.message)
                    reject()
                })
            })
            
        }
    }
}